import { LstTypeBase } from '../base/cls-lst-type-base'
import { makeObservable } from 'mobx'
// constructor (SecuredItm)
/**
 * Initializes a Secured item instance by assigning all properties from the input data object.
 *
 * @param {Object} data - Raw data representing a secured item.
 */
export class SecuredItm {
	constructor(data) {
		// Initialize Secured item properties from data
		Object.assign(this, data)
	}
}

// constructor (Secured)
/**
 * Creates an instance of the Secured list class by extending `LstTypeBase` with `SecuredItm`.
 * Passes the item class and initial list to the parent constructor.
 * Also prepares the class for MobX observability if needed.
 *
 * @param {Array<Object>} list - Initial array of secured item data objects.
 */
export class Secured extends LstTypeBase {
	_class = 'Secured'
	constructor(list = []) {
		// Pass the Secured class and list to the parent class constructor
		super(SecuredItm, list)

		makeObservable(this, {
			// Add properties here if Secured has specific properties
		})
	}
}
